import {
  memo,
  Dispatch,
  SetStateAction,
  useEffect,
  useState,
} from "react";
import { DialogDetails, DialogInfoField } from "components/shared";
import { Grid, Divider } from "@material-ui/core";
import api from "services/api";
import { IOrder, IAddressee } from "config/interfaces";
import { convertDateAndTime, getOrderStatusDescription } from "utils";
import { useError } from "hooks";

interface OrderDetailsProps {
  order: IOrder.Order;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

function OrderDetails({ order, open, setOpen }: OrderDetailsProps) {
  const { verifyError } = useError();
  const [loading, setLoading] = useState(true);
  const [complements, setComplements] = useState([] as IAddressee.EndeCompl[]);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const response = await api.patch("/api_front/ClientUserGroupSearch", {
          IDUSUARIO: order.IDUSUARIODEST,
        });
        const userGroup = response.data;
        setComplements(userGroup[0].ENDECOMPL);
      } catch (err: any) {
        verifyError(err.response.status);
      } finally {
        setLoading(false);
      }
    })();
  }, [order]);

  const Content = (
    <Grid container spacing={2}>
      <Grid item container spacing={2}>
        <DialogInfoField
          item
          xs={12}
          sm={6}
          lg={3}
          title="ID DO MODULOCKER"
          value={order?.IDMCM}
        />
        <DialogInfoField
          item
          xs={12}
          sm={6}
          lg={4}
          title="MODULOCKER"
          value={order?.DSMCM}
        />
        <DialogInfoField
          item
          xs={12}
          title="LOGRADOURO"
          value={`${order.LOGRADOURO} ${order.END_NUMERO} - ${order.BAIRRO} - ${order.DSCIDADE}/${order.DSUF}`}
        />
      </Grid>

      <Divider style={{ width: "100%", margin: "8px 0" }} />

      <Grid item container spacing={2}>
        <DialogInfoField
          item
          xs={3}
          title="DESTINATÁRIO"
          value={order.NMUSUARIO}
        />
        {order?.GRUPO?.map((element, index) => (
          <DialogInfoField
            key={index}
            item
            xs={12}
            sm={6}
            lg={3}
            title={`GRUPO ${index + 1}`}
            value={element.DSGRUPOUSUARIO}
          />
        ))}

        {complements?.map((comp) => (
          <DialogInfoField
            key={comp.IDTIPOCOMPLEMENTO}
            item
            xs={12}
            sm={6}
            lg={3}
            title={comp.DSCOMPLEMENTO ?? ""}
            value={comp.VLCOMPLEMENTO}
          />
        ))}
      </Grid>

      <Divider style={{ width: "100%", margin: "8px 0" }} />

      <Grid item container spacing={2}>
        <DialogInfoField
          item
          xs={12}
          sm={6}
          lg={3}
          title="BOX"
          value={order.NUMERO}
        />
        <DialogInfoField
          item
          xs={12}
          sm={6}
          lg={3}
          title="TAMANHO"
          value={order.DESCRICAO}
        />
        <DialogInfoField
          item
          xs={12}
          sm={6}
          lg={3}
          title="DATA DA ENTREGA"
          value={convertDateAndTime(order.DHINICIO)}
        />
        <DialogInfoField
          item
          xs={12}
          sm={6}
          lg={3}
          title="DATA DA RETIRADA"
          value={convertDateAndTime(order.DHFIM)}
        />
        <DialogInfoField
          item
          xs={12}
          sm={6}
          lg={3}
          title="STATUS"
          value={getOrderStatusDescription(order.STTRANSACAO)}
        />
      </Grid>
    </Grid>
  );

  return loading ? null : (
    <>
      <DialogDetails
        title="Informações da Encomenda"
        open={open}
        setOpen={setOpen}
        content={Content}
      />
    </>
  );
}

export default memo(OrderDetails);
